export default "__VITE_ASSET__BJ8w83ty__"